import dynamic from 'next/dynamic'
import Meta from 'components/meta/meta'
import PageHead from 'components/page-head/page-head'

const Products = dynamic(() => import('components/hits/products'))

// Maistas ir gėrimai > Gėrimai > Kava
// Maistas ir gėrimai > Maistas > Saldainiai ir šokoladas
// Namai ir interjeras > Namų dekoras > Namų kvapai
// Namai ir interjeras > Namų dekoras > Žvakės
// Vonios ir grožio reikmenys > Muilai
// Vonios ir grožio reikmenys > SPA > Masažui
// Žaislai ir žaidimai > Žaidimai ir dėlionės > Galvosūkiai
// Žaislai ir žaidimai > Žaidimai ir dėlionės > Stalo žaidimai
// Apranga > „Unisex“ apranga suaugusiems > Pižamos ir chalatai
// Apranga > „Unisex“ apranga suaugusiems > Pončai

export default function Page() {
    const ogDescription = ''
    const ogTitle = 'Idėjos romantiškam pasimatymo vakarui'
    const title = 'Idėjos romantiškam pasimatymo vakarui'

    return (
        <>
            <Meta title={ogTitle} description={ogDescription} />
            <PageHead title={title} />
            <Products
                filter={`hierarchical_taxonomies.lvl2:"Namai ir interjeras > Namų dekoras > Biožidiniai" OR hierarchical_taxonomies.lvl2:"Namai ir interjeras > Namų dekoras > Žvakidės" OR hierarchical_taxonomies.lvl2:"Apranga > „Unisex“ apranga suaugusiems > Pončai" OR hierarchical_taxonomies.lvl2:"Apranga > „Unisex“ apranga suaugusiems > Pižamos ir chalatai" OR hierarchical_taxonomies.lvl2:"Žaislai ir žaidimai > Žaidimai ir dėlionės > Stalo žaidimai" OR hierarchical_taxonomies.lvl2:"Žaislai ir žaidimai > Žaidimai ir dėlionės > Galvosūkiai" OR hierarchical_taxonomies.lvl2:"Vonios ir grožio reikmenys > SPA > Masažui" OR hierarchical_taxonomies.lvl1:"Vonios ir grožio reikmenys > Muilai" OR hierarchical_taxonomies.lvl2:"Namai ir interjeras > Namų dekoras > Žvakės" OR hierarchical_taxonomies.lvl2:"Namai ir interjeras > Namų dekoras > Namų kvapai" OR hierarchical_taxonomies.lvl2:"Maistas ir gėrimai > Gėrimai > Kava" OR hierarchical_taxonomies.lvl2:"Maistas ir gėrimai > Maistas > Saldainiai ir šokoladas"`}
                skipAudiences={true}
            />
        </>
    )
}
